module.exports = __webpack_public_path__ + "static/img/qrcode.f565ad2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrcode.jpg
// module id = Ftoc
// module chunks = 5